module.exports = __webpack_public_path__ + "img/jingzhuang7.8c4d3fc3.jpg";